var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 67,
    viewBox: "0 0 53 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6418 26.122V22.2109C19.6455 21.2666 20.0198 20.3623 20.6826 19.6959C21.3455 19.0295 22.2429 18.6554 23.1785 18.6554H30.8154C31.751 18.6554 32.6484 19.0295 33.3113 19.6959C33.9741 20.3623 34.3484 21.2666 34.3521 22.2109V26.1505H37.8465V22.2109C37.8465 20.325 37.1043 18.5162 35.783 17.1826C34.4618 15.849 32.6699 15.0999 30.8014 15.0999H23.1785C21.31 15.0999 19.518 15.849 18.1968 17.1826C16.8756 18.5162 16.1333 20.325 16.1333 22.2109V26.1505L19.6418 26.122Z",
    fill: "url(#paint0_linear_95_1638)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4284 53.8268C46.9191 46.8938 47.4232 35.1443 40.5545 27.5836C33.6858 20.0228 22.0452 19.514 14.5545 26.4469C7.06383 33.3799 6.55968 45.1294 13.4284 52.6902C20.2972 60.2509 31.9377 60.7598 39.4284 53.8268Z",
    fill: "url(#paint1_linear_95_1638)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8006 53.1635C45.9128 46.5808 46.3915 35.4251 39.8698 28.2465C33.3482 21.0678 22.2959 20.5846 15.1838 27.1673C8.07165 33.7499 7.59298 44.9056 14.1146 52.0843C20.6362 59.2629 31.6885 59.7461 38.8006 53.1635Z",
    fill: "url(#paint2_linear_95_1638)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0598 51.2012C43.1203 45.5879 43.5251 36.0784 37.9638 29.9611C32.4026 23.8439 22.9812 23.4353 16.9206 29.0486C10.8601 34.6619 10.4553 44.1714 16.0166 50.2887C21.5779 56.4059 30.9992 56.8145 37.0598 51.2012Z",
    fill: "url(#paint3_linear_95_1638)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8091 47.6255V38.1035H23.7031V35.6735H24.2971C24.7771 35.6735 25.1491 35.5535 25.4131 35.3135C25.6771 35.0735 25.8091 34.7435 25.8091 34.3235V34.1255H28.2391V47.6255H25.8091Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0889 41.1266C13.0858 38.213 13.9224 35.3613 15.4968 32.9192C17.0713 30.477 19.3155 28.5499 21.956 27.3726C24.5964 26.1952 27.5192 25.8186 30.3681 26.2885C33.2169 26.7584 35.8689 28.0546 38.0007 30.0191C36.6435 28.5247 35.0007 27.3232 33.1712 26.4868C31.3417 25.6504 29.3634 25.1965 27.3555 25.1525C25.3476 25.1084 23.3516 25.4752 21.4878 26.2305C19.624 26.9859 17.9311 28.1143 16.5109 29.5478C15.0907 30.9812 13.9728 32.69 13.2244 34.5712C12.476 36.4524 12.1127 38.4671 12.1563 40.4938C12.2 42.5205 12.6496 44.5174 13.4783 46.364C14.3069 48.2106 15.4973 49.8688 16.9778 51.2386C14.4705 48.4798 13.0823 44.8704 13.0889 41.1266V41.1266Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.67
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4376 28.4973C38.8375 31.3878 40.2637 34.9742 40.5098 38.7373C40.5098 42.7242 38.9406 46.5479 36.1475 49.3671C33.3545 52.1863 29.5662 53.7701 25.6162 53.7701C21.8854 53.5336 18.3287 52.0926 15.4712 49.6599C16.7922 51.276 18.4332 52.5956 20.2891 53.5339C22.145 54.4723 24.1747 55.0087 26.248 55.1088C28.3213 55.2089 30.3925 54.8704 32.3286 54.1152C34.2647 53.3599 36.0231 52.2044 37.4908 50.723C38.9586 49.2415 40.1033 47.4667 40.8516 45.5125C41.5999 43.5582 41.9352 41.4677 41.836 39.3749C41.7369 37.2822 41.2054 35.2335 40.2758 33.3603C39.3461 31.487 38.0388 29.8306 36.4376 28.4973V28.4973Z",
    fill: "#F44B16"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.969 0.408691L22.3324 18.5704C22.2434 18.7943 22.2122 19.0374 22.2418 19.2767C22.2715 19.5161 22.361 19.744 22.5019 19.9388C22.6428 20.1337 22.8305 20.2892 23.0474 20.3906C23.2642 20.4921 23.5031 20.5362 23.7415 20.5188H25.1505L32.5057 0.408691H28.969Z",
    fill: "#1268C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4213 0.408691L25.0662 20.5188H28.5042L35.8735 0.408691H32.4213Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8588 0.408577L30.2227 15.7685L28.5037 20.4903H30.9554C31.2864 20.4869 31.6056 20.3661 31.8572 20.149C32.0603 19.994 32.2125 19.7809 32.294 19.5374L39.3391 0.380127L35.8588 0.408577Z",
    fill: "#EB3723"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.69,
    d: "M34.126 14.6023L32.2943 19.5659C32.2161 19.8111 32.0632 20.0251 31.8575 20.1775C31.61 20.4014 31.2881 20.5232 30.9557 20.5188H23.671C23.4308 20.5373 23.19 20.4934 22.9714 20.3912C22.7529 20.2891 22.5639 20.1321 22.4226 19.9352C22.2813 19.7384 22.1923 19.5082 22.1642 19.2668C22.1361 19.0254 22.1697 18.7807 22.2619 18.5561L28.8703 0.479736L34.126 14.6023Z",
    fill: "url(#paint4_linear_95_1638)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6163 0.408691H21.1782L28.5193 20.4904H30.9428C31.2738 20.4871 31.5931 20.3662 31.8446 20.1491L30.2242 15.7402L24.6163 0.408691Z",
    fill: "#1268C6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.739 0.408691L25.0942 20.5188H28.5322L21.1771 0.408691H17.739Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2871 0.408691L21.3323 19.566C21.4292 19.8458 21.6103 20.0881 21.8503 20.2589C22.0903 20.4298 22.3772 20.5206 22.6709 20.5188H25.1226L17.7674 0.408691H14.2871Z",
    fill: "#EB3723"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_1638",
    x1: 16.1474,
    y1: 20.6038,
    x2: 37.8465,
    y2: 20.6038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_95_1638",
    x1: 35.7126,
    y1: 48.9561,
    x2: 16.2433,
    y2: 29.6672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_95_1638",
    x1: 16.9517,
    y1: 29.993,
    x2: 40.5168,
    y2: 53.3397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_95_1638",
    x1: 45.0857,
    y1: 58.4076,
    x2: 8.73539,
    y2: 22.3942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_95_1638",
    x1: 31.167,
    y1: 9.98015,
    x2: 27.7027,
    y2: 11.6472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121E3D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.7b24f8e55074c6a37ac5052c32648510.svg";
export { ForwardRef as ReactComponent };